import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Form from "../../../../components/Forms/Form";
import {
  alphaNumeric,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class SegmentCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      // user: {},
      loading: false,
      fields: []
    };

    this.error = this.error.bind(this);
    this.fieldsMount = this.fieldsMount.bind(this);
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const { id } = this.props.match.params;
    this.setState(
      () => ({
        loading: true
      }),
      () => {
        axios
          .get(`${URL.api}configuration/module/list`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(resp => {
            this.setState(
              () => {
                let fieldsArray = this.fieldsMount(resp.data.data);
                return {
                  fields: fieldsArray
                };
              },
              () => {
                if (!id) {
                  this.setState(() => ({
                    loading: false
                  }));
                }
              },
              error => {
                this.error(error.response.statusText);
              }
            );
          });
      }
    );

    if (id) {
      this.setState(
        () => ({
          loading: true
        }),
        () => {
          axios
            .get(`${URL.api}classification/segment/singleView/${id}`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(resp => {
              this.setState(
                () => ({
                  segment: resp.data.data
                }),
                () => {
                  this.setState(() => ({
                    edit: true,
                    loading: false
                  }));
                },
                error => {
                  this.error(error.response.statusText);
                }
              );
            });
        }
      );
    }
  }

  fieldsMount(modulo) {
    let optionsModuloArray = [];
    for (let i = 0; i <= modulo.length; i++) {
      let obj = {};
      if (i < modulo.length) {
        obj = {
          value: modulo[i].id,
          label: modulo[i].name,
          name: modulo[i].name
        };

        optionsModuloArray[i] = obj;
      }

      if (i === modulo.length) {
        obj = {
          value: 0,
          label: "Sem Módulo Comercial",
          name: "Sem Módulo Comercial"
        };

        optionsModuloArray[i] = obj;
      }
    }

    let Fields = [
      {
        name: "name",
        label: "Nome",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      },
      {
        name: "abbreviation",
        label: "Abreviação",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      },
      {
        name: "order",
        label: "Ordem",
        type: "number",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      },
      {
        name: "module_id",
        label: "Modulo",
        type: "select",
        required: true,
        options: optionsModuloArray,
        icon: "fa fa-text-width",
        validate: [required]
      }
    ];

    return Fields;
  }

  enviar(value) {
    let obj = {
      loggedUser: this.props.user.user.id,
      name: value.name,
      abbreviation: value.abbreviation,
      order: value.order,
      module_id: value.module_id
    };
    axios
      .post(`${URL.api}classification/segment/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.props.history.push("/segment/list");
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  atualizar(value) {
    let obj = {
      loggedUser: this.props.user.user.id,
      name: value.name,
      abbreviation: value.abbreviation,
      order: value.order,
      module_id: value.module_id
    };
    axios
      .post(`${URL.api}classification/segment/update/${value.id}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.props.history.push("/segment/list");
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  render() {
    let buttons = [
      {
        name: "Enviar",
        submit: false,
        icon: "fa fa-cloud",
        iconSide: "left",
        custom: this.enviar,
        color: "primary"
      }
    ];

    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/segment/list", to: "/segment/list" }]}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Form
            avatar
            fields={this.state.fields}
            back
            history={this.props.history}
            buttons={buttons}
            onSubmit={this.state.edit ? this.atualizar : this.enviar}
            initialValues={this.state.segment}
            edit={this.state.edit}
          />
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SegmentCreate);
